import * as React from 'react';
import BaggageDialogHeader from '@websky/core/src/Baggage/UpgradeBaggageDialog/components/BaggageDialogHeader/BaggageDialogHeader';
const OverriddenBaggageDialogHeader = props => {
    return React.createElement(BaggageDialogHeader, Object.assign({}, props, { switchVariant: 'secondary' }));
};
export default OverriddenBaggageDialogHeader;
